import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagMW = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M0 25c0 3.058.55 5.987 1.555 8.695L25 34.782l23.445-1.087A24.947 24.947 0 0 0 50 25c0-3.058-.55-5.988-1.555-8.696L25 15.217 1.555 16.304A24.947 24.947 0 0 0 0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M25 0C14.251 0 5.088 6.784 1.555 16.304h46.89C44.913 6.784 35.75 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M48.445 33.696H1.555C5.088 43.216 14.251 50 25 50c10.75 0 19.913-6.785 23.445-16.304Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m32.471 11.955-3.053-1.436 1.626-2.957-3.315.635-.42-3.35-2.31 2.464-2.31-2.464-.42 3.35-3.315-.635 1.626 2.957-3.053 1.436h14.944Z"
}));
FlagMW.displayName = 'FlagMW';
export default withFlagWrapper(FlagMW);
//# sourceMappingURL=index.js.map